import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { from, lastValueFrom, Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { NO_AUTH_ROUTES } from '../constants';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return from(this.handle(request, next));
  }

  private async handle(request: HttpRequest<any>, next: HttpHandler): Promise<HttpEvent<any>> {
    if (NO_AUTH_ROUTES.some(part => request.url.endsWith(part)))
      return await lastValueFrom(next.handle(request));

    const token = await this.authService.getAccessToken();

    if (!token)
      return await lastValueFrom(next.handle(request));

    const cloned = request.clone({
      headers: request.headers.append('Authorization', `Bearer ${token}`)
    });

    return await lastValueFrom(next.handle(cloned));
  }
}
